import React from "react";
import { Col } from "reactstrap";
import DashPanel from "../common/DashPanel";
import TopCompanyRow from "../common/TopCompanyRow";
import { T } from "../../constants/theme";
import { topSellingCompanies } from "../../data/dashboardMockData";

const TopSellingCompaniesSection = ({ loading }) => {
  const sortedCompanies = [...topSellingCompanies].sort((a, b) => b.sale - a.sale);
  const maxSale = topSellingCompanies.length
    ? Math.max(...topSellingCompanies.map((x) => x.sale))
    : 1;

  return (
    <Col xl={6}>
      <DashPanel
        title="Top Selling Companies"
        icon="bx bx-medal"
        iconColor={T.yellow}
        loading={loading}
      >
        <div className="sad-company-list">
          {sortedCompanies.map((c, i) => (
            <TopCompanyRow
              key={i}
              company={c}
              rank={i + 1}
              maxSale={maxSale}
              loading={loading}
            />
          ))}
        </div>
      </DashPanel>
    </Col>
  );
};

export default TopSellingCompaniesSection;
